document.addEventListener('click', function (e) {
  var t = e.target.closest('[data-nav-toggle]');
  if (t) { t.closest('.hdr__in').classList.toggle('is-open'); return; }
  var q = e.target.closest('[data-qty]');
  if (q) {
    var input = q.parentElement.querySelector('input');
    var step = q.dataset.qty === 'up' ? 1 : -1;
    var v = Math.max(parseInt(input.min || '1', 10), (parseInt(input.value, 10) || 1) + step);
    input.value = v;
    if (input.dataset.cartLine) input.form.requestSubmit ? input.form.requestSubmit() : input.form.submit();
  }
});
document.addEventListener('change', function (e) {
  var f = e.target.closest('[data-auto-submit]');
  if (f) f.submit();
});
